export class ContainerOver {
  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      const target = document.querySelectorAll('.js-container-over')

      if (!target) return

      let innerWidth = 0

      const resize = () => {
        innerWidth = window.innerWidth
        target.forEach((item) => {
          const clientLeft = item.parentNode.getBoundingClientRect().left
          const clientWidth = item.parentNode.getBoundingClientRect().width

          if (item.classList.contains('-reverse')) {
            // 左寄せ
            item.style.width = clientLeft + clientWidth + 'px'
            item.style.marginLeft = -1 * clientLeft + 'px'
          } else {
            // 右寄せ
            item.style.width = clientLeft + clientWidth + 'px'
          }
        })
      }

      resize()
      window.addEventListener('load', resize)
      window.addEventListener('resize', resize)
      window.addEventListener('orientationchange', () => {
        setTimeout(resize, 50)
      })
    })
  }
}
